import { useState, useEffect, useContext } from 'react';
import parse, { domToReact } from 'html-react-parser';
import { getContentByTitle } from '@/customercenter-ui/components/product/details/helpers/utils/productDataUtils';
import { getSiteBaseLink } from '@/helpers/utils/siteUtils';
import { AccordianSection } from '../../../../../../customercenter-ui/components/product/details/components/productDetails/AccordianSection';
import { ProductContext } from '../../contexts';
interface AccordianProps {
  pdpDrawerFlag?: boolean;
}

const PdpAccordianDetail: React.FC<AccordianProps> = () => {
  const { initialSize, skuToRulesObject } = useContext(ProductContext);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [itemLevelMsg, setItemLevelMsg] = useState<string[]>([]);

  const transform = (node: any, index: any) => {
    if (index?.name === 'a') {
      const href = getSiteBaseLink(index?.attribs?.href);
      return (
        <a target="_blank" href={href} rel="noreferrer">
          {domToReact(index?.children)}
        </a>
      );
    } else {
      return node;
    }
  };

  useEffect(() => {
    let itemLevelMsgId: string[] = [];
    const fetchProductRules = async () => {
      try {
        const isSkuPresentInState = Object.keys(skuToRulesObject).some((key) => key === initialSize?.key);
        if (isSkuPresentInState) {
          itemLevelMsgId = skuToRulesObject[initialSize?.key] || [];
        }
        if (itemLevelMsgId.length > 0) {
          const fetchContent = async () => {
            const contentPromises = itemLevelMsgId.map(async (id: string) => {
              const data: any = await getContentByTitle(id, false);
              return data?.htmlContentEntries?.[0]?.rich_text_and_html_editor || '';
            });
            const contents = await Promise.all(contentPromises);
            setItemLevelMsg(contents);
          };
          await fetchContent();
        } else {
          setItemLevelMsg([]);
        }
      } catch (error) {
        console.error('Error while fetching product details', error);
      }
    };
    if (initialSize?.key) {
      fetchProductRules();
    }
  }, [skuToRulesObject, initialSize]);

  return (
    <section className="mx-auto w-full">
      {itemLevelMsg?.length > 0 &&
        itemLevelMsg.map((content, index) => (
          <div key={index} className="mx-auto flex justify-center pt-4">
            {parse(content, { transform })}
          </div>
        ))}
      <section>
        <section className="pt-4" id="accordianDetails">
          <AccordianSection />
        </section>
      </section>
    </section>
  );
};

export default PdpAccordianDetail;
